import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export const useSearchStore = create(devtools((set) => ({
  search: '',
  setSearch: (search) => set({ search }),
}), {
  name: 'useSearchStore',
}));
